import { CalendarClock } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "appointments",
  icon: CalendarClock,
  tabs: [
    { to: "/appointments", label: "nav.calendar", perm: ["appointments.appointment.read"] },
    { to: "/appointments/list", label: "nav.appointments", perm: ["appointments.appointment.read"] },
  ],
  create: [{ label: "create.appointment", to: "/appointments?new=1", perm: "appointments.appointment.create" }],
  settings: { to: "/settings/appointments", perm: ["appointments.settings.create", "appointments.settings.update"] },
  setup: { services: "/settings/appointments", first_appointment: "/appointments?new=1" },
};
